/**
 * 获取当天日期，格式化为 xxxx-xx-xx
 * @returns {string} 格式化后的日期字符串（如 2025-07-14）
 */
export function getTodayFormatted() {
    const date = new Date(); // 获取当前日期对象

    // 获取年、月、日（注意月份从 0 开始，需 +1）
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 月份范围 0-11 → 1-12
    const day = date.getDate();

    // 补零处理：确保月份和日期为两位数（如 3 → '03'）
    const formattedMonth = month.toString().padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');

    // 拼接为 xxxx-xx-xx 格式
    return `${year}-${formattedMonth}-${formattedDay}`;
}

export function getTomorrowDate() {
    const today = new Date();
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000); // 今天的时间戳加上一天的毫秒数

    // 获取年、月、日（注意月份从 0 开始，需 +1）
    const year = tomorrow.getFullYear();
    const month = tomorrow.getMonth() + 1; // 月份范围 0-11 → 1-12
    const day = tomorrow.getDate();

    // 补零处理：确保月份和日期为两位数（如 3 → '03'）
    const formattedMonth = month.toString().padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');

    // 拼接为 xxxx-xx-xx 格式
    return `${year}-${formattedMonth}-${formattedDay}`;
}

export function getSeqTypeDate() {
    const date = new Date()
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}${month}${day}`;
}

export function getdateTypeDate() {
    // 定义补0函数：数字小于10时在前面补0，否则返回原数字
    const padZero = (num) => num < 10 ? `0${num}` : num;

    const date = new Date(); // 获取当前日期对象
    const year = date.getFullYear();
    // 使用补0函数处理月份（月份从0开始，所以要+1）
    const month = padZero(date.getMonth() + 1);
    const day = padZero(date.getDate());

    const hour = padZero(date.getHours());
    const minute = padZero(date.getMinutes());
    const second = padZero(date.getSeconds());

    return `${year}${month}${day}${hour}${minute}${second}`;
}

export function changeDateMode(date) {

    // 获取年、月、日（注意月份从 0 开始，需 +1）
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 月份范围 0-11 → 1-12
    const day = date.getDate();

    // 补零处理：确保月份和日期为两位数（如 3 → '03'）
    const formattedMonth = month.toString().padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');

    // 拼接为 xxxx-xx-xx 格式
    return `${year}-${formattedMonth}-${formattedDay}`;
}

export function formatTimestamps(timestamps) {
    // 将毫秒时间戳转换为Date对象
    const dates = timestamps.map(ts => new Date(ts));

    // 获取今天的日期（忽略时间部分）
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 星期几的映射
    const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

    const formattedDates = dates.map(date => {
        // 创建仅包含日期部分的副本
        const dateOnly = new Date(date);
        dateOnly.setHours(0, 0, 0, 0);

        // 计算与今天的差值（以天为单位）
        const timeDiff = dateOnly - today;
        const delta = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

        let weekdayPart, datePart, fullDatePart;
        if (delta === 0) {
            weekdayPart = "今天";
        } else {
            weekdayPart = weekdays[date.getDay()];
        }
        datePart = `${date.getMonth() + 1}月${date.getDate()}日`;
        fullDatePart =
            `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        return [weekdayPart, datePart, fullDatePart];
    });

    // 计算天数差（注意：这里直接使用时间戳差值计算）
    const nights = Math.floor((dates[1] - dates[0]) / (1000 * 60 * 60 * 24));
    const nightsInfo = [`共${nights}晚`];
    const nightsSum = nights

    return [...formattedDates, ...nightsInfo, nightsSum];
}